// @flow

import createParser from './createParser';

window.Scalpel = {
  createParser
};
